import React from 'react';
import loaderGif from "../../../../../assets/images/loader.gif";
import { Tooltip } from 'react-tooltip'
import Select from 'react-select';
const DealsTable = ({ tableData, onSort, updateStatus, mapDemandPartner, demandList, agencyList , countryList ,brandList, mapAgency, mapBrand, mapCountry , loader }) => {

  const handleSort = (column) => {
    onSort(column);
  };


  const addDemandPartner = (e, dealId) => {
    mapDemandPartner(e, dealId)
  }
  const addAgency = (val, dealId) => {
    mapAgency(val, dealId)
  }

  const addCountry = (val, dealId) => {
    mapCountry(val, dealId)
  }

  const totalRowStyle = {
    position: 'sticky',
    bottom: 0,
    zIndex: 2,
    backgroundColor: '#eaf2ff',
    fontWeight: 700,
    color: '#0d6efd'
  };

  const totalCellStyle = {
    fontWeight: 700,
    color: '#0d6efd'
  };

  return (
    <>
      <div className="table-responsive custom-table">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>Sr. No.</th>
              <th className="partner" onClick={() => handleSort('supply_partner_name')}>Supply Partner <i className="fas fa-sort"></i></th>
              <th className="partner" onClick={() => handleSort('demand_partner_name')}>Demand Partner <i className="fas fa-sort"></i></th>
              <th className="partner" onClick={() => handleSort('agency_partner_name')}>Agencies <i className="fas fa-sort"></i></th>
              <th className="partner" onClick={() => handleSort('brand_partner_name')}>Brand <i className="fas fa-sort"></i></th>
              <th className="deal-name" onClick={() => handleSort('country_name')}>Country <i className="fas fa-sort"></i></th>
              <th className="deal-name" onClick={() => handleSort('deal_name')}>Deal Name <i className="fas fa-sort"></i></th>
              {/* <th onClick={() => handleSort('imp')}>Total Impression <i className="fas fa-sort"></i></th> */}
              <th className='margin' onClick={() => handleSort('revenue')}>Total Advertiser Cost <i className="fas fa-sort"></i></th>
              {/* <th className="status">Status</th> */}
            </tr>
          </thead>
          {!loader ?
            <tbody>
              {tableData && tableData.length > 0 ? (
                tableData.map((item, i) => {
                  const isTotalRow = item?.is_total;

                  return (
                    <tr key={i} style={isTotalRow ? totalRowStyle : undefined}>
                      <td style={isTotalRow ? totalCellStyle : undefined}>{isTotalRow ? '' : i + 1}</td>
                      <td className="wrap-string partner" style={isTotalRow ? totalCellStyle : undefined}>{isTotalRow ? 'Total' : item?.supply_partner_name}</td>
                      <td className="partner" style={isTotalRow ? totalCellStyle : undefined}>
                        {isTotalRow ? '' : item.demand_partner_name == null ? (
                          <Select className='tableSelect'
                            // value={selectedPartner}
                            onChange={(e) => addDemandPartner(e, item?.id)}
                            options={demandList}
                            getOptionLabel={(demandList) => demandList.name}
                            getOptionValue={(demandList) => demandList.id}
                          />
                        ) : (
                          <span>{item?.demand_partner_name}</span>
                        )}
                      </td>

                      <td className="partner" style={isTotalRow ? totalCellStyle : undefined}>
                        {isTotalRow ? '' : item.agency_name == null ? (
                          <Select className='tableSelect'
                            // value={selectedPartner}
                            onChange={(e) => addAgency(e, item?.id)}
                            options={agencyList}
                            getOptionLabel={(agencyList) => agencyList.name}
                            getOptionValue={(agencyList) => agencyList.id}
                          />
                        ) : (
                          <span>{item?.agency_name}</span>
                        )}
                      </td>

                      <td className="partner" style={isTotalRow ? totalCellStyle : undefined}>
                        {isTotalRow ? '' : item.brand_name == null ? (
                          <Select className='tableSelect'
                            // value={selectedPartner}
                            onChange={(e) => mapBrand(e, item?.id)}
                            options={brandList}
                            getOptionLabel={(brandList) => brandList.name}
                            getOptionValue={(brandList) => brandList.id}
                          />
                        ) : (
                          <span>{item?.brand_name}</span>
                        )}
                      </td>

                      <td className="deal-name" style={isTotalRow ? totalCellStyle : undefined}>
                        {isTotalRow ? '' : item.country == null ? (
                          <Select className='tableSelect'
                            // value={selectedPartner}
                            onChange={(e) => addCountry(e, item?.id)}
                            options={countryList}
                            getOptionLabel={(countryList) => countryList.name}
                            getOptionValue={(countryList) => countryList?.ccode}
                          />
                        ) : (
                          <span>{item?.country}</span>
                        )}
                      </td>

                      <td className="deal-name" style={isTotalRow ? totalCellStyle : undefined}>{isTotalRow ? '' : item?.deal_name}</td>
                      {/* <td className="text-end date">{item?.imp}</td> */}
                      <td className="text-end date" style={isTotalRow ? totalCellStyle : undefined}>{item?.revenue}</td>
                      {/* <td className="text-center status">
                      <label className="custom-switch">
                        <input
                          type="checkbox"
                          checked={item?.status === 1}
                          onClick={() => updateStatus(item.id, item.status === 1 ? 0 : 1)}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td> */}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="8" className="text-center">
                    No Data Found
                  </td>
                </tr>
              )}
            </tbody>
            :
            <div className={`loader ${loader ? 'show' : ''}`} >
              <label>
                <img src={loaderGif} />
              </label>
            </div>
          }
        </table>
      </div>
      <Tooltip id="my-tooltip-inline" place="top" style={{ backgroundColor: "rgb(182, 191, 183)", color: "#222" }} />
    </>
  );
};

export default DealsTable;
